import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-js';
import { sources } from 'constants/invoices';
import { Autocomplete } from 'components/FormFields';
import { handleShowError, handleError } from 'utils';

export const InvoiceSourceTypesSelect = ({
  label,
  margin,
  variant,
  omitFields,
  asyncErrors,
  field: { name, value },
  form: { errors, touched, setFieldValue },
  customParams: { cleanUp },
}) => {
  const [defaultValue, setDefaultValue] = useState('');

  useEffect(() => {
    if (value || value === '') {
      const defaultVal = sources.find((e) => e.value === value);

      if (defaultVal) {
        setDefaultValue(defaultVal);
      } else {
        setDefaultValue('');
      }
    }
  }, [value, sources]) // eslint-disable-line

  return (
    <Autocomplete
      openOnFocus
      name={name}
      label={label}
      margin={margin}
      variant={variant}
      id="invoice-sources"
      value={defaultValue}
      error={handleError(name, errors, touched, asyncErrors)}
      onChange={(ev, val) => {
        if (cleanUp) {
          cleanUp();
        }
        setFieldValue(name, val?.value || '');
      }}
      options={sources.filter((value) => omitFields.indexOf(value))}
      helperText={handleShowError(name, errors, touched, asyncErrors)}
      getOptionSelected={(option, value) => {
        return option?.value === value?.value || '';
      }}
      getOptionLabel={(option) => (option ? i18n.t(`source_types.${option?.label}`) : '')}
    />
  );
};

InvoiceSourceTypesSelect.propTypes = {
  label: PropTypes.string,
  asyncErrors: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  field: PropTypes.shape({
    value: PropTypes.any,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
  }),
  style: PropTypes.object,
  form: PropTypes.shape({
    errors: PropTypes.object,
    touched: PropTypes.object,
  }),
  omitFields: PropTypes.array,
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled']),
};

InvoiceSourceTypesSelect.defaultProps = {
  required: true,
  disabled: false,
  form: {
    errors: {},
    touched: {},
    setFieldValue: () => {},
  },
  field: {
    name: 'invoiceSourceTypesSelect',
  },
  style: {},
  field: {},
  omitFields: [],
  label: 'Status',
  variant: 'standard',
};
